import { Box, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useInstantSearch } from 'react-instantsearch';
import Breadcrumb, { Crumb } from '../../common/components/BreadCrumb';
import { FeatureFlagKey, isFeatureEnabled } from '../../common/utils/featureFlags';
import { discoveryViewAtom } from '../state';
import { applyFamilyPath, familyLevelLabelKey, familyPathFromRefinementList } from './family-level-facets';

export default function DiscoveryClassificationHeading(): React.JSX.Element | null {
  const { t } = useTranslation(['common', 'discovery', 'product-family', 'product-classification']);
  const discoveryView = useAtomValue(discoveryViewAtom);
  const { indexUiState, setIndexUiState } = useInstantSearch();

  if (!isFeatureEnabled(FeatureFlagKey.PRODUCT_CLASSIFICATION)) {
    return null;
  }

  const rootLabel = discoveryView === 'PRODUCTS' ? t('common:all_products') : t('discovery:all_suppliers');
  const path = familyPathFromRefinementList(indexUiState.refinementList);
  const title = path.length
    ? t(familyLevelLabelKey(path[path.length - 1], path.length - 1))
    : rootLabel;
  const items: Crumb[] = [
    {
      label: rootLabel,
      onClick: path.length ? () => applyFamilyPath(setIndexUiState, []) : undefined,
    },
    ...path.map((code, depth): Crumb => ({
      label: t(familyLevelLabelKey(code, depth)),
      onClick: depth < path.length - 1
        ? () => applyFamilyPath(setIndexUiState, path.slice(0, depth + 1))
        : undefined,
    })),
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        py: 1,
        px: 2,
        '& .MuiTypography-root, & .MuiBreadcrumbs-root': {
          m: 0,
        },
      }}
    >
      <Typography variant="headlineMedium">
        {title}
      </Typography>
      <Breadcrumb items={items} />
    </Box>
  );
}
